export const CREATE_SUPPORT_ISSUE_REQUEST = 'USER/CREATE_SUPPORT_ISSUE_REQUEST';
export const CREATE_SUPPORT_ISSUE_SUCCESS = 'USER/CREATE_SUPPORT_ISSUE_SUCCESS';
export const CREATE_SUPPORT_ISSUE_FAILURE = 'USER/CREATE_SUPPORT_ISSUE_FAILURE';
